export default "__VITE_ASSET__CETX482j__"